import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumDocumentTypeGroup implements BaseEnumType {
  private static allValues: EnumDocumentTypeGroup[] = []; // make sure this is top-most
  
  public static other = new EnumDocumentTypeGroup(0, "Other", "enum_document_type_group_other");
  public static productionAndStock = new EnumDocumentTypeGroup(1, "ProductionAndStock", "enum_document_type_group_production_and_stock");
  public static salesAndDistribution = new EnumDocumentTypeGroup(2, "SalesAndDistribution", "enum_document_type_group_sales_and_distribution");
  public static duty = new EnumDocumentTypeGroup(3, "Duty", "enum_document_type_group_duty");
  public static hidden = new EnumDocumentTypeGroup(4, "Hidden", "enum_document_type_group_hidden");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumDocumentTypeGroup.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isOther() { return this === EnumDocumentTypeGroup.other; }
  public isProductionAndStock() { return this === EnumDocumentTypeGroup.productionAndStock; }
  public isSalesAndDistribution() { return this === EnumDocumentTypeGroup.salesAndDistribution; }
  public isDuty() { return this === EnumDocumentTypeGroup.duty; }
  public isHidden() { return this === EnumDocumentTypeGroup.hidden; }

  public static getValues(): readonly EnumDocumentTypeGroup[] {
    return EnumDocumentTypeGroup.allValues;
  }

  public static getValuesExcept0(): readonly EnumDocumentTypeGroup[] {
    return EnumDocumentTypeGroup.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumDocumentTypeGroup {
    const found = EnumDocumentTypeGroup.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumDocumentTypeGroup - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumDocumentTypeGroup): EnumDocumentTypeGroup {
    const found = name ? EnumDocumentTypeGroup.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumDocumentTypeGroup - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumDocumentTypeGroup>): boolean {
    return this.key === other?.key;
  }
}